import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-important-dates',
  templateUrl: './important-dates.component.html',
  styleUrls: ['./important-dates.component.scss']
})
export class ImportantDatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
